/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TeamsControllerRemoveMutationResponse, TeamsControllerRemovePathParams, TeamsControllerRemoveQueryParams, TeamsControllerRemove401, TeamsControllerRemove403, TeamsControllerRemove404 } from "../../models/teamsController/TeamsControllerRemove";

function getTeamsControllerRemoveUrl(id: TeamsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/teams/${id}` as const }  
  return res
}

/**
 * @description Deletes a team. By default, performs a soft delete (marks as deleted but keeps in database for recovery). Use hardDelete=true to permanently remove the team and its scope from the database.
 * @summary Delete a team
 * {@link /api/v1/teams/:id}
 */
export async function teamsControllerRemove(id: TeamsControllerRemovePathParams["id"], params?: TeamsControllerRemoveQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TeamsControllerRemoveMutationResponse, ResponseErrorConfig<TeamsControllerRemove401 | TeamsControllerRemove403 | TeamsControllerRemove404>, unknown>({ method : "DELETE", url : getTeamsControllerRemoveUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}